export const ReviewConfConstants = {
    maxLengthDescription: 500
};
